/*
 * @Author: shiguang
 * @Date: 2023-04-26 20:23:35
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2023-08-31 17:14:52
 * @Description: Page1
 */
import React, { useState } from 'react';
import { Layout, Space, Menu, message } from 'antd';
// eslint-disable-next-line no-duplicate-imports
import type { MenuProps } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { strings } from '@/i18n/i18n';
import { RouteItem } from '@/config/router';
import styles from './index.module.scss';
import { LayoutHeader } from './Header';
type MenuItem = Required<MenuProps>['items'][number];
function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group'
): MenuItem {
    return {
        key,
        icon,
        children,
        label,
        type
    } as MenuItem;
}
function mapRouteItemToMenuItem(
    routes?: RouteItem[],
    parent?: RouteItem,
    t?: any
) {
    if (!routes) {
        return;
    }
    return routes
        .filter((route) => !(route.showMenu === false))
        .map(
            (route) =>
                getItem(
                    t(route.title || ''),
                    parent?.path ? parent?.path + '/' + route.path : route.path,
                    route.icon,
                    mapRouteItemToMenuItem(route.children, route, t)
                ),
            ''
        );
}
const { Header, Sider, Content } = Layout;
type CommonLayoutProps = {
    routes: RouteItem[];
    showSlider: boolean;
    title?: string;
};
const CommonLayout: React.FC<CommonLayoutProps> = (props) => {
    const [t, i18n] = useTranslation();
    document.title = strings.t(props.title || '');
    if (window.sessionStorage.getItem('successMsg')) {
        message.success(window.sessionStorage.getItem('successMsg'));
        window.sessionStorage.removeItem('successMsg');
    }
    const _location = useLocation();
    const navigate = useNavigate();
    const menuItems: MenuProps['items'] = mapRouteItemToMenuItem(
        props.routes,
        undefined,
        strings.t
    );

    const onClick: MenuProps['onClick'] = (info) => {
        navigate(info.key);
    };

    return (
        <Space
            direction="vertical"
            style={{
                width: '100%'
            }}
            size={[0, 48]}
        >
            <Layout
                style={{
                    minHeight: '100vh'
                }}
            >
                <LayoutHeader />
                <Layout className={styles.main}>
                    {props.showSlider !== false && (
                        <Sider>
                            <div className={styles.backWrap}>
                                <i
                                    className={
                                        'iconfont icon-a-fanhuishouye2x ' +
                                        styles.icon
                                    }
                                    onClick={() => {
                                        window.location.href = '/';
                                    }}
                                >
                                    {' '}
                                    <span className={styles.backtext}>
                                        {strings.t('返回首页')}
                                    </span>
                                </i>
                            </div>
                            <Menu
                                onClick={onClick}
                                selectedKeys={[_location.pathname]}
                                defaultOpenKeys={['/manage']}
                                mode="inline"
                                items={menuItems}
                            />
                        </Sider>
                    )}

                    <Content className={styles.content}>
                        <Outlet />
                    </Content>
                </Layout>
            </Layout>
        </Space>
    );
};
export default CommonLayout;
